import React from 'react';
import HeaderComponent from './HeaderComponent';


const HeaderContainer = (props) => {
	return <HeaderComponent {...props} />;
};

export default HeaderContainer;
